module.exports = __webpack_public_path__ + "static/media/h8.c384f256.jpg";